/**
 * Quick-buy button feedback enhancement
 *
 * - クリック時: 短いpulseアニメ
 * - 成功時 (cart-update): 「✓ 追加しました」を1.5秒表示、緑フラッシュ
 * - 失敗時 (cart-error): 赤フラッシュ + ボタン揺れ
 * - カートアイコンバッジ: 追加成功時にスケールアップ演出
 *
 * Depends on pubsub.js (PUB_SUB_EVENTS) loaded globally.
 */

(function () {
  'use strict';

  if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') {
    return;
  }

  // ---------- クリック時の即時フィードバック ----------
  document.addEventListener('click', (event) => {
    const btn = event.target.closest('.card__quick-buy-button--submit');
    if (!btn || btn.disabled) return;

    btn.classList.add('is-clicked');
    setTimeout(() => btn.classList.remove('is-clicked'), 250);
  });

  // ---------- 成功時: 該当ボタンに成功表示 ----------
  subscribe(PUB_SUB_EVENTS.cartUpdate, (data) => {
    if (data && data.source !== 'product-form') return;
    if (!data || !data.productVariantId) return;

    // variant ID に一致する quick-buy form を探す
    // (hidden input 経由 or select の現在値 経由)
    const form = findQuickBuyForm(data.productVariantId);
    if (!form) {
      // Quick-buy以外(例: 商品詳細ページの通常フォーム)の追加はスキップ
      // ただしカートバッジのパルスだけは実行
      pulseCartBadge();
      return;
    }

    const button = form.querySelector('.card__quick-buy-button--submit');
    if (!button) return;

    flashSuccess(button);
    pulseCartBadge();
  });

  // ---------- 失敗時: 該当ボタンにエラー表示 ----------
  subscribe(PUB_SUB_EVENTS.cartError, (data) => {
    if (data && data.source !== 'product-form') return;
    if (!data || !data.productVariantId) return;

    const form = findQuickBuyForm(data.productVariantId);
    if (!form) return;

    const button = form.querySelector('.card__quick-buy-button--submit');
    if (!button) return;

    flashError(button);
  });

  // ---------- variant ID に一致する quick-buy form を探す ----------
  function findQuickBuyForm(variantId) {
    const targetValue = String(variantId);
    const forms = document.querySelectorAll('.card__quick-buy-form');
    for (const form of forms) {
      const idInput = form.querySelector('[name="id"]');
      if (!idInput) continue;
      if (String(idInput.value) === targetValue) {
        return form;
      }
    }
    return null;
  }

  // ---------- 成功演出: ボタンに「✓ 追加しました」を1.5秒表示 ----------
  function flashSuccess(button) {
    if (button.dataset.feedbackBusy === '1') return;
    button.dataset.feedbackBusy = '1';

    const originalHTML = button.innerHTML;
    button.classList.add('is-success');
    button.innerHTML =
      '<span class="card__quick-buy-check" aria-hidden="true">✓</span><span>追加しました</span>';

    setTimeout(() => {
      button.classList.remove('is-success');
      button.innerHTML = originalHTML;
      delete button.dataset.feedbackBusy;
    }, 1500);
  }

  // ---------- エラー演出: ボタンに赤フラッシュ + 揺れ ----------
  function flashError(button) {
    button.classList.add('is-error');
    setTimeout(() => button.classList.remove('is-error'), 600);
  }

  // ---------- カートアイコンバッジのパルス ----------
  function pulseCartBadge() {
    const cartIcon = document.getElementById('cart-icon-bubble');
    if (!cartIcon) return;

    cartIcon.classList.add('is-pulsing');
    setTimeout(() => cartIcon.classList.remove('is-pulsing'), 600);
  }
})();
